import { useQuery } from "@tanstack/react-query";
import Tabs from "../../../elements/Tabs";
import AdvanceSettings from "./AdvanceSettings";
import Advertisement from "./Advertisement";
import UserPrivilege from "./UserPrivilege";
import UserProfile from "./UserProfile";
import { userDetails } from "../../../../services/userService";

const ManageUser = ({
  getResponse = () => {},
  close = () => {},
  data,
  selectedTab,
  setSelectedTab = () => {},
}) => {
  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useQuery({
    queryKey: ["user-details", data?._id],
    queryFn: async () => {
      const res = await userDetails({ id: data?._id });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  const tabs = [
    {
      label: "User Profile",
      icon: "fa-light fa-user",
      content: (
        <UserProfile
          details={details}
          getResponse={getResponse}
          loading={detailsLoading || detailsFetching}
        />
      ),
    },
    // {
    //   label: "Edit Privileges",
    //   icon: "fa-light fa-shield-check",
    //   content: <UserPrivilege />,
    // },
    // {
    //   label: "Advertisement",
    //   icon: "fa-light fa-rectangle-ad",
    //   type: "image",
    //   content: <Advertisement />,
    // },
    {
      label: "Advance Settings",
      icon: "fa-light fa-gear",
      type: "image",
      content: (
        <AdvanceSettings
          details={details}
          getResponse={getResponse}
          loading={detailsLoading || detailsFetching}
        />
      ),
    },
  ];

  return (
    <div className="px-6 mt-4 h-full">
      <Tabs
        items={tabs}
        selectedIndex={selectedTab}
        setSelectedIndex={setSelectedTab}
      />
    </div>
  );
};

export default ManageUser;
